import { render, staticRenderFns } from "./LeavingExpose.vue?vue&type=template&id=6b7550f7&scoped=true&"
import script from "./LeavingExpose.vue?vue&type=script&lang=ts&"
export * from "./LeavingExpose.vue?vue&type=script&lang=ts&"
import style0 from "./LeavingExpose.vue?vue&type=style&index=0&id=6b7550f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7550f7",
  null
  
)

export default component.exports